import type { MouseEvent } from "react";
import React, { useMemo } from "react";
import cx from "classnames";
import { UncontrolledTooltip } from "reactstrap";
import { Icon } from "components";
import s from "./IconButton.module.scss";

type IconButtonProps = {
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  disabled?: boolean;
  iconClassName?: string;
  icon: string;
  title?: string;
  testId?: string;
  tooltipText?: React.JSX.Element | string;
  iconPrefix?: string;
  color?: string;
  hoverColor?: string;
  id: string;
};

export const IconButton = ({
  onClick = () => {},
  className,
  disabled = false,
  iconClassName = "icon-16",
  icon,
  title,
  testId,
  tooltipText,
  iconPrefix = "trox",
  id,
}: IconButtonProps) => {
  const iconId = useMemo(() => `iconButton-${id || crypto.randomUUID()}`, [id]);

  return (
    <>
      <button
        className={cx(s.iconButton, className)}
        onClick={(e: MouseEvent<HTMLButtonElement>) => !disabled && onClick(e)}
        data-testid={testId}
        title={title}
        id={iconId}
        disabled={disabled}
      >
        <Icon iconName={icon} prefix={iconPrefix} className={iconClassName} />
      </button>
      {tooltipText && (
        <UncontrolledTooltip target={iconId} placement="top">
          {tooltipText}
        </UncontrolledTooltip>
      )}
    </>
  );
};
